import { ChatBoxContainer, GenericCard } from '@/components/dashboard';
import AppRoutes from '@/const/routes';
import { useChatMessages, useShowChat } from '@/hooks';
import useDeviceWidth from '@/hooks/useDeviceWidth';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import * as React from 'react';

interface Props {
	className?: string;
}

export const InboxChat: React.FC<Props> = ({ className }) => {
	const width = useDeviceWidth();
	const router = useRouter();
	const { isConversationOver, resetContext, isChatAI } = useChatMessages();
	const { openShowChatBox } = useShowChat();

	React.useEffect(() => {
		// This page cannot exist in resolutions higher than mobile.
		// redirect to dashboard page and open chat AI box
		if (
			width >= 1024 &&
			router.pathname === AppRoutes.CLIENTAPP_CLAIM_CHAT &&
			!isChatAI
		) {
			openShowChatBox();
			router.push(AppRoutes.CLIENTAPP_DASHBOARD);
		}
	}, [width]);

	return (
		<GenericCard
			className={clsx(
				'relative p-4 border border-green-base shadow-chatBox md:!h-[78vh] 3xl:!h[80vh]',
				className
			)}
		>
			<ChatBoxContainer
				close={resetContext}
				from="inbox"
				className={clsx('mb-2', { '!max-h-[58vh]': !isConversationOver })}
			/>
		</GenericCard>
	);
};
